/* eslint-disable no-return-await */
import axios from 'axios'
import axiosWrapper from '@/utils/request'

/**
 * @function getInvoiceMeta
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const getInvoiceMeta = (accountId) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/invoices_list_counters`
  })
}

/**
 * @function fetchPendingTasks
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchPendingTasks = (accountId) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}`,
    params: {
      include: ['customer_pending_task_flows']
    }
  })
}

/**
 * @function fetchInvoiceStageCounters
 * @description To fetch Invoices of stage counters
 * @param {String} accountId - Logged user's account id
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchInvoiceStageCounters = (accountId) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/invoices_stage_counters`
  })
}

/**
 * @function fetchExporterMetaData
 * @description To fetch Exporters data and its meta data according to the params provided
 * @param {String} accountId - Logged user's account id
 * @param {{include: Array.<String>}} params - the paramter object
 * @param {String} responseType - type of response e.g. blob
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExporterMetaData = async (accountId, params, responseType) => {
  const res = await axiosWrapper({
    url: `/v1/business/exporters/${accountId}`,
    params,
    responseType
  })
  return res
}

/**
 * @function fetchPendingInvoices
 * @description To fetch pending invoice of the exporter
 * @param {String} accountId - Logged user's account id
 * @param {{limit: Number}} params - the paramter object
 * @param {Boolean} progressBar - progress bar
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchPendingInvoices = (accountId, params, progressBar) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/pending_invoices`,
    params,
    progressBar // TODO: remove this
  })
}

/**
 * @function fetchLEOData
 * @description To fetch LEO data of the exporter
 * @param {String} accountId - Logged user's account id
 * @param {{limit: Number}} params - the paramter object
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchLEOData = (accountId, params) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/leo_data`,
    params
  })
}

/**
 * @function fetchExportersTransactions
 * @description To fetch all transaction of the exporter
 * @param {String} accountId - Logged user's account id
 * @param {Boolean} progressBar - the progress bar
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExportersTransactions = (accountId, progressBar) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/transactions_summary`,
    progressBar // TODO: remove this
  })
}

/**
 * @function fetchExportersInvoiceStatement
 * @description - needs to be added
 * @param {String} accountId - Logged user's account id
 * @param {Object} params - the query parameters to be passed
 * @param {String} responseType - reponse type of the api call
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExportersInvoiceStatement = (accountId, params, responseType) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/call/render_invoices_statement`,
    params,
    responseType
  })
}

/**
 * @function fetchExportersAadhaarSignableDocs
 * @description - needs to be added
 * @param {String} accountId - Logged user's account id
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExportersAadhaarSignableDocs = (accountId, data, isMx) => {
  return axiosWrapper({
    url: `business/exporters/${accountId}/call/${
      isMx ? 'generate_aadhaar_signable_docs' : 'generate_esign_docs'
    }`,
    method: 'POST',
    data
  })
}

/**
 * @function fetchAllInvoices
 * @description - needs to be added
 * @param {String} endpoint - endpoint for base url provided
 * @param {String} accountId - Logged user's account id
 * @param {Object} params - the query parameters to be passed
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchAllInvoices = (endpoint, accountId, params) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/${endpoint}`,
    params
  })
}

let call
/**
 * @function fetchExportersPassbookMetaOnce
 * @description - needs to be added
 * @param {String} endpoint - endpoint for base url provided
 * @param {String} accountId - Logged user's account id
 * @param {Object} params - the query parameters to be passed
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExportersPassbookMetaOnce = (endpoint, accountId, params) => {
  if (call) {
    call.cancel('Only one request allowed at a time.')
  }
  call = axios.CancelToken.source()
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/${endpoint}`,
    params,
    cancelToken: call.token
  })
}

/**
 * @function fetchExportersPassbookMeta
 * @description - fetches passbook details by endpoint assigned
 * @param {String} endpoint - endpoint for base url provided
 * @param {String} accountId - Logged user's account id
 * @param {Object} params - the query parameters to be passed
 * @param {String} responseType - reponse type of the api call
 * @returns {Promise} returns a promise from the api called
 * @author Steven Fernandes
 */
const fetchExportersPassbookMeta = (
  endpoint,
  accountId,
  params,
  responseType
) => {
  return axiosWrapper({
    url: `/v1/business/exporters/${accountId}/view/${endpoint}`,
    params,
    responseType
  })
}

/**
 * @function fetchBankAccounts
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 */
const fetchBankAccounts = (token, accountId) => {
  return axiosWrapper({
    url: `/business/exporters/${accountId}/view/bank_list`,
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}

/**
 * @function fetchBankDetailsData
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 */
const fetchBankDetailsData = (token, account) => {
  return axiosWrapper({
    url: `/business/beneficiary_bank_details/${account}`,
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}

/**
 * @function archiveBank
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 */
const archiveBank = (token, data, accountId) => {
  return axiosWrapper({
    method: 'POST',
    url: `v1/business/exporters/${accountId}/call/archive_bank_detail`,
    headers: {
      Authorization: 'Bearer ' + token
    },
    data
  })
}

/**
 * @function requestAMCallback
 * @description - needs to be added
 * @returns {Promise} returns a promise from the api called
 */
const requestAMCallback = (accountId, params = {}) => {
  return axiosWrapper({
    method: 'GET',
    url: `v1/business/exporters/${accountId}/call/request_am_callback`,
    params
  })
}

/**
 * @function archiveBank
 * @description - download excel file of account summary filter by buyer
 * @returns {Promise} returns a promise from the api called
 */
const downloadAccountSummaryExcel = (accountId, params = {}) => {
  return axiosWrapper({
    url: `/v2/business/exporters/${accountId}/account_summary_report`,
    params,
    responseType: 'blob'
  })
}

/**
 * @function generateLegalEsignUrl
 * @description - to generate esign url based on data and place
 * @returns {Promise} returns a promise from the api called
 */
const generateLegalEsignUrl = (accountId, data = {}) => {
  return axiosWrapper({
    method: 'POST',
    url: `v1/business/exporters/${accountId}/generate_esign_url`,
    data
  })
}

/**
 * @function fetchLegalData
 * @description - to fetch document list and sales manager info
 * @returns {Promise} returns a promise from the api called
 */
const fetchLegalData = (accountId, data = {}) => {
  return axiosWrapper({
    method: 'GET',
    url: `v1/business/exporters/${accountId}/portal_esign_data`,
    data
  })
}
/**
 * @function fetchSignedDocument
 * @description - to fetch signed document
 * @returns {Promise} returns a promise from the api called
 */
const fetchSignedDocument = (accountId, data = {}) => {
  return axiosWrapper({
    method: 'GET',
    url: `v1/business/exporters/${accountId}/esigned_agreement_url`,
    data
  })
}

export default {
  getInvoiceMeta,
  fetchPendingTasks,
  fetchInvoiceStageCounters,
  fetchExporterMetaData,
  fetchPendingInvoices,
  fetchExportersTransactions,
  fetchLEOData,
  fetchAllInvoices,
  fetchExportersPassbookMeta,
  fetchExportersPassbookMetaOnce,
  fetchExportersAadhaarSignableDocs,
  fetchExportersInvoiceStatement,
  fetchBankAccounts,
  fetchBankDetailsData,
  archiveBank,
  requestAMCallback,
  downloadAccountSummaryExcel,
  generateLegalEsignUrl,
  fetchLegalData,
  fetchSignedDocument
}
